import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, ThemeProvider } from '@material-ui/core';
import { CONFIRM_TYPES } from '../contexts/ConfirmContext';

export const ConfirmationDialog = ({ open, title = '', variant = '', description = '', type = CONFIRM_TYPES.confirm, onSubmit, onClose, theme }) => {
  const confirm = (
    <Button key='Confirm' color='primary' variant='contained' onClick={onSubmit}>
      <strong>Confirm</strong>
    </Button>
  );
  const yes = (
    <Button key='Yes' color='primary' variant='contained' onClick={() => onSubmit(true)}>
      <strong>Yes</strong>
    </Button>
  );
  const no = (
    <Button key='No' color='secondary' onClick={() => onSubmit(false)}>
      <strong>No</strong>
    </Button>
  );
  const cancel = (
    <Button key='Cancel' color='secondary' onClick={onClose} autoFocus>
      <strong>Cancel</strong>
    </Button>
  );

  var buttons: any[] = [];
  switch (type) {
    case CONFIRM_TYPES.yesnocancel:
      buttons = [yes, no, cancel];
      break;
    case CONFIRM_TYPES.yesno:
      buttons = [yes, no];
      break;
    case CONFIRM_TYPES.confirm:
    default:
      buttons = [confirm, cancel];
      break;
  }

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} transitionDuration={{ exit: 0 }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {description.split('\n').map((desc, i) => (
            <DialogContentText key={'desc_' + i}>{desc}</DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>{buttons}</DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
